import Footer from '../../components/template/Footer';
import Header from '../../components/template/Header';

export default function CSRContent() {
  const focusAreas = [
    {
      title: 'Education for All',
      description:
        'Ensuring that underprivileged children have access to quality education, learning resources, and digital tools to build a brighter future.',
      icon: '📚',
    },
    {
      title: 'Healthcare & Medical Aid',
      description:
        'Providing medical assistance to individuals battling life-threatening illnesses and promoting community health and well-being.',
      icon: '🏥',
    },
    {
      title: 'Livelihood & Skill Development',
      description:
        'Empowering women and youth through vocational training and entrepreneurship programs to foster financial independence.',
      icon: '🎯',
    },
    {
      title: 'Disaster Relief & Humanitarian Aid',
      description:
        'Delivering timely support and rehabilitation to communities affected by natural disasters and crises.',
      icon: '🤝',
    },
    {
      title: 'Environmental Sustainability',
      description:
        'Encouraging eco-friendly initiatives, awareness drives, and tree plantation programs to protect and preserve the environment.',
      icon: '🌱',
    },
  ];

  // ✅ Now includes logos
  const companies = [
    {
      name: 'Accord Manpower Services',
      logo: 'images/csr/accord.png',
    },
    {
      name: 'Dermapuritys',
      logo: '/images/csr/derma.webp',
    },
    {
      name: 'Ferolight',
      logo: '/images/csr/ferolight.svg',
    },
    {
      name: 'GG Valves',
      logo: '/images/csr/gg-valves-logo.png',
    },
    {
      name: 'JP Fibers',
      logo: '/images/csr/jpfiber.webp',
    },
    {
      name: 'Kryptonite Solutions',
      logo: '/images/csr/kryptonite.jpg',
    },
    {
      name: 'Ludhiana Beverages Pvt Ltd',
      logo: '/images/csr/ludhiana_beverages_pvt_ltd_logo.png',
    },
    {
      name: 'M Swasth',
      logo: '/images/csr/m-swasth-new-logo.png',
    },
    {
      name: 'Pravek Kalp Pvt Ltd',
      logo: '/images/csr/Pravek-Logo_Black-Logotype.png',
    },
    {
      name: 'Teamup',
      logo: '/images/csr/teamup.png',
    },
    {
      name: 'Tterra Kitchens',
      logo: '/images/csr/ttera.webp',
    },
    {
      name: 'Jayaram Charitable Trust',
    },
    {
      name: 'Amit Mehra Foundation',
    },
    {
      name: 'Filantro First Exports Limited',
      logo: '/images/csr/filantro.png',
    },
    {
      name: 'Chaman Lal Setia Exports',
      logo: '/images/csr/chaman-logo.png',
    },
  ];

  return (
    <div className='csr-page'>
      <Header />

      {/* ========================= HERO ========================= */}
      <section className='csr-hero text-black text-center py-5'>
        <div className='container position-relative'>
          <h6 className='text-uppercase text-warning mb-3'>
            Corporate Social Responsibility (CSR)
          </h6>
          <h1 className='display-3 fw-bold mb-3'>
            Partnering for <span className='text-warning'>Impact</span>
          </h1>
          <p className='lead mb-4'>Empowering Communities. Inspiring Change.</p>
        </div>
      </section>

      {/* ========================= ABOUT ========================= */}
      <section className='py-5 bg-white text-center'>
        <div className='container'>
          <span className='badge bg-warning text-dark mb-4'>
            About National Organisation for Social Empowerment
          </span>
          <p className='lead text-muted mb-3'>
            The National Organisation for Social Empowerment (National NGO) is a
            non-profit dedicated to improving lives through education,
            healthcare, livelihood programs, and humanitarian support.
          </p>
          <p className='text-muted fs-5'>
            With a strong network and years of experience, we have worked
            towards uplifting marginalized communities and promoting inclusive
            growth across India.
          </p>
        </div>
      </section>

      {/* ========================= CSR PHILOSOPHY ========================= */}
      <section className='py-5 bg-light text-center'>
        <div className='container'>
          <span className='badge bg-warning text-dark mb-4'>
            Our CSR Philosophy
          </span>
          <div
            className='card shadow p-4 border-start border-4 border-warning mx-auto'
            style={{ maxWidth: '800px' }}
          >
            <p className='fs-5 text-muted mb-0'>
              We believe that true progress begins with compassion and shared
              responsibility. Our CSR initiatives are rooted in empathy,
              inclusion, and accountability. We aim to create long-term,
              sustainable impact by working hand-in-hand with corporates and
              communities to build a more equitable society.
            </p>
          </div>
        </div>
      </section>

      {/* ========================= FOCUS AREAS ========================= */}
      <section className='py-5 bg-white'>
        <div className='container text-center'>
          <span className='badge bg-warning text-dark mb-4'>
            Our Key CSR Focus Areas
          </span>
          <div className='row g-4'>
            {focusAreas.map((area, index) => (
              <div key={index} className='col-md-6 col-lg-4'>
                <div className='card h-100 border-0 shadow-sm csr-focus-card'>
                  <div className='card-body'>
                    <div className='display-4 mb-3'>{area.icon}</div>
                    <h5 className='card-title fw-bold mb-2'>{area.title}</h5>
                    <p className='card-text text-muted'>{area.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ========================= PARTNER BENEFITS ========================= */}
      <section className='py-5 text-white csr-partner-section text-center'>
        <div className='container'>
          <span className='badge bg-warning text-dark mb-4'>
            Why Partner With Us
          </span>
          <p className='lead text-light mb-5'>
            Partnering with National NGO ensures your organization’s CSR
            initiatives create meaningful, measurable change. We provide
            end-to-end program management — from planning to execution and
            reporting — ensuring transparency and impact at every step.
          </p>

          <ul
            className='list-unstyled fs-5 text-start mx-auto mb-5'
            style={{ maxWidth: '600px' }}
          >
            {[
              'Strengthen your brand reputation through authentic social commitment',
              'Engage employees through purposeful CSR initiatives',
              'Create lasting, measurable social impact',
            ].map((benefit, i) => (
              <li key={i} className='mb-3 d-flex align-items-start'>
                <div className='me-3 text-warning fs-4'>✓</div>
                <span>{benefit}</span>
              </li>
            ))}
          </ul>

          <div className='p-5 rounded bg-dark bg-opacity-50 border border-warning'>
            <h3 className='fw-bold mb-3 text-warning'>
              Partnership Opportunities
            </h3>
            <p className='text-light fs-5 mb-4'>
              We invite corporates, institutions, and individuals to collaborate
              with us in shaping a better tomorrow. Together, we can develop
              tailor-made CSR programs that align with your company’s vision and
              values while making a genuine difference in the lives of those who
              need it most.
            </p>
            <button className='btn btn-warning text-black fw-semibold'>
              Get in Touch:{' '}
              <a
                href='mailto:support@nationalngo.org'
                style={{ color: 'black' }}
              >
                support@nationalngo.org
              </a>
            </button>
          </div>
        </div>
      </section>

      {/* ========================= COMPANY LOGOS ========================= */}
      <section className='company-logos-section py-5 bg-light'>
        <div className='container'>
          <div className='text-center mb-5'>
            <span className='badge bg-warning text-dark mb-3 px-3 py-2 fw-semibold'>
              Partners
            </span>
            <h2 className='display-5 fw-bold mb-3 text-dark'>
              Our Corporate Partners
            </h2>
            <p
              className='text-muted fs-5 mx-auto'
              style={{ maxWidth: '700px' }}
            >
              Together with our valued partners, we create sustainable social
              impact and drive meaningful change.
            </p>
          </div>

          <div className='row g-4 mb-5'>
            {companies.map((company, index) => {
              const isTeamup = company.name.toLowerCase().includes('teamup'); // detect teamup
              const hasLogo = company.logo && company.logo.trim() !== '';

              return (
                <div key={index} className='col-6 col-md-4 col-lg-3'>
                  <div
                    className='card company-card text-center border-0 shadow-sm mt-5'
                    style={{
                      height: '160px',
                      backgroundColor: isTeamup ? '#d5d5d5' : 'white', // darker background for white logos
                    }}
                  >
                    <div className='card-body d-flex flex-column align-items-center justify-content-center text-center'>
                      {hasLogo ? (
                        <img
                          src={company.logo}
                          alt={company.name}
                          className='img-fluid company-logo mb-3'
                          style={{
                            maxHeight: '70px',
                            objectFit: 'contain',
                          }}
                        />
                      ) : (
                        <div
                          className='fw-bold text-dark mb-3'
                          style={{
                            fontSize: '1.2rem',
                            lineHeight: '1.3',
                            textAlign: 'center',
                          }}
                        >
                          {company.name}
                        </div>
                      )}
                      <p
                        className='fw-bold text-secondary company-name mb-0'
                        style={{ fontSize: '0.95rem' }}
                      >
                        {company.name}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ========================= CONTACT ========================= */}
      {/* <section className='py-4 text-center border-top border-2 border-warning'>
        <div className='container'>
          <h3 className='fw-bold mb-2'>Get in Touch</h3>
          <p className='fs-5'>
            Email:{' '}
            <a
              href='mailto:support@nationalngo.org'
              className='text-warning fw-semibold'
            >
              support@nationalngo.org
            </a>
          </p>
        </div>
      </section> */}

      <Footer />
    </div>
  );
}
